(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  // The answer is measured and moved by hand. A <details> hides what is inside
  // it the instant it closes, so a closing item has to be animated first and
  // told to close afterwards — which is why the click is taken over rather
  // than the toggle event being listened to.
  function reveal(item) {
    const head = item.querySelector('.faq__head');
    const body = item.querySelector('.faq__answer');
    if (!head || !body || item.dataset.faqWired === 'true') return;
    item.dataset.faqWired = 'true';

    const still = window.matchMedia('(prefers-reduced-motion: reduce)');
    let moving = null;

    function slide(opening) {
      if (moving) moving.cancel();

      // The foot padding travels with the height. Left alone it stayed at its
      // full depth while the box went to nothing, so the answer could not
      // actually reach zero and every close stopped short with a band of empty
      // colour still open.
      const pad = getComputedStyle(body).paddingBlockEnd;
      const full = body.scrollHeight;

      const shut = { blockSize: '0px', paddingBlockEnd: '0px', opacity: 0 };
      const open = { blockSize: full + 'px', paddingBlockEnd: pad, opacity: 1 };

      moving = body.animate(opening ? [shut, open] : [open, shut], {
        duration: 380,
        easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
        fill: 'both'
      });

      moving.onfinish = () => {
        // Closed before the animation is dropped, never after. Dropping it
        // first hands the answer back its real height for one frame, and that
        // frame is a full flash of the text on the way out.
        if (!opening) item.open = false;
        moving.cancel();
        moving = null;
      };
    }

    head.addEventListener('click', (event) => {
      if (still.matches) return;
      event.preventDefault();

      if (item.open) {
        slide(false);
        return;
      }

      // One at a time, and the closing one animated rather than cut. This is
      // what the name attribute used to do, and it is why it was taken off:
      // the browser closes the other item in the same frame it opens this one,
      // with no movement at all, so the page dropped by the height of a whole
      // answer while the new one was still on its way up. Closed here instead,
      // the two heights change together and the list stays where it is.
      document.querySelectorAll('.faq__item[open]').forEach((other) => {
        if (other !== item && other.closest('.faq') === item.closest('.faq')) {
          other.dispatchEvent(new CustomEvent('faq:close'));
        }
      });

      // Opened first, because nothing inside a closed details can be measured.
      item.open = true;
      slide(true);
    });

    item.addEventListener('faq:close', () => slide(false));
  }

  function initFaq(root) {
    (root || document).querySelectorAll('.faq__item').forEach(reveal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFaq());
  } else {
    initFaq();
  }

  document.addEventListener('shopify:section:load', (event) => initFaq(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // The dialog does the hard parts — focus, Escape, inertness behind it — so
  // there is only the opening, the reporting of state, and closing on a click
  // outside the panel, which a dialog does not do on its own.
  function wireDrawer(toggle) {
    const drawer = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!drawer || toggle.dataset.wired === 'true') return;
    toggle.dataset.wired = 'true';

    toggle.addEventListener('click', () => {
      drawer.showModal();
      // Before the browser settles on the first link inside.
      drawer.focus();
      toggle.setAttribute('aria-expanded', 'true');
    });

    drawer.addEventListener('close', () => {
      drawer.classList.remove('is-closing');
      toggle.setAttribute('aria-expanded', 'false');
    });

    // Closed by hand rather than by the dialog element on its own: the panel
    // is marked as leaving, and only once the slide has run does it actually
    // close. Held open that long, it keeps its place in the top layer and its
    // backdrop, so the way out looks like the way in played backwards.
    const dismiss = () => {
      if (drawer.classList.contains('is-closing')) return;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (motion.matches) {
        drawer.close();
        return;
      }
      drawer.classList.add('is-closing');
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        drawer.close();
      };
      drawer.addEventListener('transitionend', (event) => {
        if (event.propertyName === 'translate') finish();
      }, { once: true });
      // A transition that never starts would otherwise leave it open.
      setTimeout(finish, 700);
    };

    const close = drawer.querySelector('.header__close');
    if (close) close.addEventListener('click', dismiss);

    // Escape asks the dialog to close immediately; the same slide is wanted.
    drawer.addEventListener('cancel', (event) => {
      event.preventDefault();
      dismiss();
    });

    // A dialog fills its own box, so a click that lands on the element itself
    // rather than on anything inside it came from the backdrop.
    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) dismiss();
    });
  }

  function initHeader(root) {
    (root || document).querySelectorAll('.header__toggle').forEach(wireDrawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initHeader());
  } else {
    initHeader();
  }

  document.addEventListener('shopify:section:load', (event) => initHeader(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  // Every copy is hidden from assistive technology and from the theme editor:
  // only the blocks the merchant actually placed should be announced or
  // selectable, however many times the row repeats them.
  function duplicate(node) {
    const copy = node.cloneNode(true);
    copy.setAttribute('aria-hidden', 'true');
    copy.removeAttribute('data-shopify-editor-block');
    copy.querySelectorAll('[data-shopify-editor-block]').forEach((child) => {
      child.removeAttribute('data-shopify-editor-block');
    });
    return copy;
  }

  // Two passes. First the row is filled: a single short block would otherwise
  // leave the bar mostly empty and open a visible gap as it scrolls, since
  // the loop can only ever show what the row contains. Then the filled row is
  // doubled, which is what makes the loop seamless — the animation slides the
  // first copy out while the second takes its place.
  function startMarquee(section) {
    const viewport = section.querySelector('.marquee__viewport');
    if (!viewport || viewport.dataset.cloned === 'true') return;

    const track = viewport.firstElementChild;
    if (!track || track.children.length === 0) return;

    const items = Array.from(track.children);
    // Bounded: a row that reports no width — web fonts still loading, or the
    // section hidden — must not spin here.
    for (let pass = 0; pass < 20 && track.scrollWidth < section.clientWidth; pass += 1) {
      items.forEach((item) => track.append(duplicate(item)));
    }

    const clone = duplicate(track);
    viewport.append(clone);
    viewport.dataset.cloned = 'true';
    section.classList.add('marquee--animated');
  }

  function initMarquees(root) {
    (root || document).querySelectorAll('.marquee').forEach(startMarquee);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMarquees());
  } else {
    initMarquees();
  }

  // The editor swaps a section's markup in place, which drops the clone.
  document.addEventListener('shopify:section:load', (event) => initMarquees(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-cards"] && !Shopify.designMode) return;
  try {
    
  // A reel that comes round, rather than one that walks to an end and stops.
  //
  // Two passes of the same photographs, so there is always a neighbour on
  // both sides of wherever it is — the trick the ticker uses, turned into a
  // scroll container. Stepping past the last one moves to its copy at the
  // head of the second pass, which looks exactly like the first; once the
  // movement has finished, the scroll is taken back by one pass with no
  // animation, and the reel is at the beginning again having appeared to
  // carry straight on.
  //
  // Counting to an index rather than nudging by a distance, because a nudge
  // stops dead at either end and a control that cannot move anything is a
  // promise the card does not keep.
  function wireOffer(card) {
    if (card.dataset.wired === 'true') return;
    card.dataset.wired = 'true';

    const strip = card.querySelector('.offer__strip');
    if (!strip) return;

    const originals = [...strip.children];
    const count = originals.length;

    // One photograph has nowhere to go, and the buttons are not drawn for it.
    if (count < 2) return;

    // The copies are hidden from assistive technology and from the theme
    // editor: only the photographs the merchant actually placed should be
    // announced or selectable, however many times the reel repeats them.
    originals.forEach((cell) => {
      const copy = cell.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.removeAttribute('data-shopify-editor-block');
      strip.append(copy);
    });

    // Measured on every use rather than once: the cell is a share of the card
    // and the card changes width with the screen.
    const span = () => {
      const first = strip.firstElementChild;
      if (!first) return 0;
      const gap = parseFloat(getComputedStyle(strip).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    };

    const rewind = () => {
      const width = span();
      if (!width) return;
      if (strip.scrollLeft >= width * count - 1) {
        strip.scrollTo({ left: strip.scrollLeft - width * count, behavior: 'auto' });
      }
    };

    // Swiping can land in the second pass as easily as the buttons can, so
    // the reel is put back whenever it comes to rest rather than only after
    // a click. scrollend where it exists; a timer behind it, because Safari
    // has no such event and would otherwise drift into the copies and stay.
    if ('onscrollend' in window) {
      strip.addEventListener('scrollend', rewind);
    } else {
      let idle;
      strip.addEventListener('scroll', () => {
        clearTimeout(idle);
        idle = setTimeout(rewind, 120);
      });
    }

    card.querySelectorAll('[data-offer-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const width = span();
        if (!width) return;

        // Read back off the strip each time: it can be swiped as well as
        // stepped, so a position of our own would go stale.
        let at = Math.round(strip.scrollLeft / width);
        const dir = Number(button.dataset.offerStep);

        // Going back from the first, there is nothing to the left — so it is
        // moved to the identical cell one pass along first, with no animation,
        // and steps back from there into what is visibly the last photograph.
        if (dir < 0 && at === 0) {
          strip.scrollTo({ left: count * width, behavior: 'auto' });
          at = count;
        }

        strip.scrollTo({ left: (at + dir) * width, behavior: 'smooth' });
      });
    });
  }

  function wireOffers(root) {
    root.querySelectorAll('.offer').forEach(wireOffer);
  }

  wireOffers(document);

  document.addEventListener('shopify:section:load', (event) => wireOffers(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panels"] && !Shopify.designMode) return;
  try {
    
  // The same two-pass fill the ticker uses, turned on its side. Every copy is
  // hidden from assistive technology and from the theme editor: only the
  // partners the merchant actually placed should be announced or selectable,
  // however many times the column repeats them.
  function copyOf(node) {
    const copy = node.cloneNode(true);
    copy.setAttribute('aria-hidden', 'true');
    // Marked so the belt can be taken back to the partners the merchant
    // actually placed, which is what rebuilding on the other axis needs.
    copy.dataset.rollCopy = 'true';
    copy.removeAttribute('data-shopify-editor-block');
    copy.querySelectorAll('[data-shopify-editor-block]').forEach((child) => {
      child.removeAttribute('data-shopify-editor-block');
    });
    return copy;
  }

  // Standing, the strip is taller than it is wide; lying down, wider than it
  // is tall. The layout already knows which way the belt runs, so it is asked
  // rather than guessed at from the viewport.
  function axisOf(box) {
    return box.clientHeight > box.clientWidth ? 'y' : 'x';
  }

  function resetRoll(box) {
    const column = box.firstElementChild;
    if (!column) return;
    column.querySelectorAll('[data-roll-copy]').forEach((copy) => copy.remove());
    delete box.dataset.rolling;
    delete box.dataset.axis;
    box.classList.remove('panel__logos--rolling', 'panel__logos--rolling-x');
  }

  function rollLogos(box) {
    if (box.dataset.rolling === 'true') return;

    const column = box.firstElementChild;
    const reel = column && column.firstElementChild;
    if (!reel || reel.children.length === 0) return;

    const axis = axisOf(box);
    const extent = () => (axis === 'y' ? reel.scrollHeight : reel.scrollWidth);
    const room = () => (axis === 'y' ? box.clientHeight : box.clientWidth);

    // A box measuring nothing along the axis it travels — images still
    // loading, or the panel not laid out yet — must not be filled against.
    // The loop below would run to its cap without ever satisfying its
    // condition, the box would never be marked done, and the next call would
    // read the copies as its own originals and multiply them again: six marks
    // became 126, then 2646.
    if (room() === 0) return;

    const marks = Array.from(reel.children);

    // Filled past the box rather than only up to it. Six partners already fit,
    // so a belt that only moved when it overflowed would never move at all —
    // and the point of the movement is that it reads as more partners than it
    // holds.
    for (let pass = 0; pass < 20 && extent() <= room(); pass += 1) {
      marks.forEach((mark) => reel.append(copyOf(mark)));
    }

    if (extent() === 0) return;

    column.append(copyOf(reel));
    box.dataset.rolling = 'true';
    box.dataset.axis = axis;
    box.classList.add(axis === 'y' ? 'panel__logos--rolling' : 'panel__logos--rolling-x');
  }

  function initLogoRolls(root) {
    (root || document).querySelectorAll('.panel__logos').forEach(rollLogos);
  }

  initLogoRolls(document);

  // Marks arriving late change whether the column outgrows its box.
  window.addEventListener('load', () => initLogoRolls(document));

  // The editor swaps a section's markup without reloading the page.
  document.addEventListener('shopify:section:load', (event) => initLogoRolls(event.target));

  // A strip that changes arrangement changes the direction it travels, and a
  // belt built for one axis is the wrong length for the other. Rebuilt from
  // the merchant's own marks when that happens, and otherwise left alone —
  // the box's flag keeps a belt that is already rolling from being filled
  // twice. Also the second chance for a strip whose images had not arrived
  // when the first pass ran.
  let settle;
  window.addEventListener('resize', () => {
    clearTimeout(settle);
    settle = setTimeout(() => {
      document.querySelectorAll('.panel__logos').forEach((box) => {
        if (box.dataset.axis && box.dataset.axis !== axisOf(box)) resetRoll(box);
      });
      initLogoRolls(document);
    }, 200);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  // The strip snaps and scrolls on its own; these only push it along by one
  // photograph, for a pointer that cannot swipe. Everything else about the
  // gallery — the snapping, the momentum, the bounds — is the browser's.
  function wirePanel(panel) {
    if (panel.dataset.wired === 'true') return;
    panel.dataset.wired = 'true';

    // A photograph gallery scrolls its strip; the review reel scrolls the box
    // its cards sit in. Either way it is the first thing here that scrolls.
    // The strip, if the panel has one. A selector list returns whichever comes
    // first in the document, and the gallery wraps its strip in a .tab__blocks
    // — so the list handed back the wrapper, which holds a single child and
    // therefore looked like a reel with nothing to scroll.
    const reel = panel.querySelector('.tab__strip')
              || panel.querySelector('.tab__blocks');
    if (!reel) return;

    panel.querySelectorAll('[data-tab-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const item = reel.firstElementChild;
        const step = item ? item.getBoundingClientRect().width : reel.clientWidth;
        const gap = parseFloat(getComputedStyle(reel).columnGap) || 0;
        reel.scrollBy({
          left: (step + gap) * Number(button.dataset.tabStep),
          behavior: 'smooth',
        });
      });
    });
  }

  // Arrows that cannot move anything are a promise the page does not keep, so
  // they stand down whenever everything already fits.
  function showArrows(panel) {
    // The strip, if the panel has one. A selector list returns whichever comes
    // first in the document, and the gallery wraps its strip in a .tab__blocks
    // — so the list handed back the wrapper, which holds a single child and
    // therefore looked like a reel with nothing to scroll.
    const reel = panel.querySelector('.tab__strip')
              || panel.querySelector('.tab__blocks');
    const arrows = panel.querySelector('.tab__arrows');
    if (!reel || !arrows) return;

    // Counted, not measured. Whether a reel overflows depends on when you ask:
    // a panel that is not the chosen one is not laid out, one being sized for
    // the shared floor is briefly out of flow at full width, and photographs
    // arrive after the first pass — each of those reads as "everything fits",
    // which is why the arrows appeared and then vanished a moment later. How
    // many items there are does not change with the moment.
    arrows.hidden = reel.children.length < 2;
  }

  function wireAll(root) {
    root.querySelectorAll('.tab__panel').forEach((panel) => {
      if (!panel.querySelector('[data-tab-step]')) return;
      wirePanel(panel);
      showArrows(panel);
    });
  }

  wireAll(document);

  // A panel that is not the chosen one is not laid out, so its reel measures
  // nothing and the arrows stand down — and nothing measured again when it was
  // opened, which left the reviews tab with two buttons that never appeared.
  // Re-asked whenever the choice changes.
  document.addEventListener('change', (event) => {
    if (!event.target.classList.contains('tab__pick')) return;
    const tabs = event.target.closest('.tabs');
    if (tabs) wireAll(tabs);
  });

  // The tallest panel is not the same one at every width.
  let settling;
  window.addEventListener('resize', () => {
    clearTimeout(settling);
    settling = setTimeout(() => wireAll(document), 200);
  });

  // Photographs arriving late change what the tallest panel is — and whether a
  // reel has anything to scroll at all. The first pass runs before any of them
  // have a size, so a strip that will overflow measures as fitting and its
  // arrows stand down; nothing brought them back.
  window.addEventListener('load', () => wireAll(document));

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => wireAll(document));
  }

  document.querySelectorAll('.tabs img').forEach((img) => {
    if (img.complete) return;
    img.addEventListener('load', () => wireAll(document), { once: true });
  });

  // The editor swaps a section's markup without reloading the page.
  document.addEventListener('shopify:section:load', (event) => wireAll(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // The gallery is a radio group, so stepping is a matter of checking the next
  // one — the CSS that draws the chosen shot needs no telling. Nothing here
  // touches display; it only moves the selection, which is the one piece a
  // group of radios cannot do for itself.
  function stepGallery(stage, step) {
    const picks = [...stage.querySelectorAll('.buy__pick')];
    if (picks.length < 2) return;
    const at = picks.findIndex((r) => r.checked);
    const next = (at + step + picks.length) % picks.length;
    picks[next].checked = true;
    picks[next].dispatchEvent(new Event('change', { bubbles: true }));
  }

  function wireGallery(stage) {
    if (stage.dataset.buyWired === 'true') return;
    stage.dataset.buyWired = 'true';
    stage.querySelectorAll('.buy__arrow').forEach((button) => {
      button.addEventListener('click', () => {
        stepGallery(stage, Number(button.dataset.buyStep));
      });
    });
  }

  function initGallery(root) {
    (root || document).querySelectorAll('.buy__stage').forEach(wireGallery);
  }

  initGallery(document);
  document.addEventListener('shopify:section:load', (e) => initGallery(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reasons"] && !Shopify.designMode) return;
  try {
    
  // Every card is absolutely placed, so the section has to reserve the height
  // itself — and it reserves the tallest, not the first, or choosing a longer
  // answer would push the page down under the reader's hands. Measured rather
  // than guessed: the text is the merchant's and can be any length.
  function floorFor(section) {
    const inner = section.querySelector('.reasons__inner');
    const cards = [...section.querySelectorAll('.reason__card')];
    if (!inner || !cards.length) return;

    // Measured at their own heights: the cards are held to the tallest by
    // this same figure, and reading them while it applies would only ever
    // find it again, never a smaller one after a resize.
    inner.style.removeProperty('--reason-floor');

    let tallest = 0;
    for (const card of cards) {
      // read it while it is laid out but not shown; visibility keeps the box
      const was = card.style.visibility;
      card.style.visibility = 'hidden';
      tallest = Math.max(tallest, card.offsetHeight);
      card.style.visibility = was;
    }
    if (tallest > 0) inner.style.setProperty('--reason-floor', tallest + 'px');
  }

  // The panel and the room under the pills take the height of the card that
  // is showing, and the cards are pinned under the pills rather than hung
  // from the foot — the foot now moves, and anything hung from it would ride
  // up and down with it. On a narrow screen the cards stand in the flow and
  // none of this applies.
  const narrow = window.matchMedia('(max-width: 64rem)');

  function fitPanel(section) {
    const inner = section.querySelector('.reasons__inner');
    const card = section.querySelector('.reason__pick:checked ~ .reason__card');
    if (!inner || !card) return;

    if (narrow.matches) {
      inner.style.removeProperty('--reason-card');
      inner.style.removeProperty('--reason-top');
      return;
    }

    const top = inner.getBoundingClientRect().top;
    let pills = 0;
    section.querySelectorAll('.reason__pill').forEach((pill) => {
      pills = Math.max(pills, pill.getBoundingClientRect().bottom - top);
    });
    // The step between the pills and the card is --space-l, a length in rems.
    const root = document.documentElement;
    const gap = (parseFloat(getComputedStyle(root).getPropertyValue('--space-l')) || 4)
      * parseFloat(getComputedStyle(root).fontSize);

    inner.style.setProperty('--reason-top', Math.round(pills + gap) + 'px');
    if (card.offsetHeight) inner.style.setProperty('--reason-card', card.offsetHeight + 'px');
  }

  function initReasons(root) {
    (root || document).querySelectorAll('.reasons').forEach((section) => {
      floorFor(section);
      fitPanel(section);
    });
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches('.reason__pick')) return;
    const section = event.target.closest('.reasons');
    if (section) fitPanel(section);
  });

  initReasons(document);

  // Web fonts land after the first pass and change how the text wraps, so the
  // tallest card is not the same one before and after they arrive.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => initReasons(document));
  }

  let settle;
  window.addEventListener('resize', () => {
    clearTimeout(settle);
    settle = setTimeout(() => initReasons(document), 200);
  });

  document.addEventListener('shopify:section:load', (event) => initReasons(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  // The cards are not all one width, so a step is measured off the next card
  // rather than assumed. The offset is written to a custom property and CSS
  // does the moving — nothing here touches style.transform directly.
  function cards(section) {
    return [...section.querySelectorAll('.review')];
  }

  // The layout item is the wrapper Shopify puts round each block, not the card
  // inside it — the wrapper is what the track lays out and what a step spans.
  function slides(section) {
    const row = section.querySelector('.reviews__row');
    return row ? [...row.children] : [];
  }

  // The merchant's own cards, without the copy the loop keeps at the end.
  function originals(section) {
    return slides(section).filter((pane) => !pane.hasAttribute('data-reviews-clone'));
  }

  // One slide to a screen is a different slider: there is no partial next card
  // to reveal, so the step is simply the screen and the row loops rather than
  // stopping at either end. Read off the layout, not off a breakpoint repeated
  // here — the CSS already decides where this happens.
  function onePerView(section) {
    const viewport = section.querySelector('.reviews__viewport');
    const first = originals(section)[0];
    if (!viewport || !first) return false;
    return first.offsetWidth >= viewport.clientWidth - 2;
  }

  // A copy of the first card, kept at the end of the track. It is what closes
  // the loop without a rewind: stepping past the last card moves forward onto
  // this one, and because it is the first card the track can then be put back
  // to the start with nothing appearing to change.
  //
  // One copy serves both directions. Going back from the first card, the track
  // is put on the copy — the same picture, at the far end of the row — and
  // steps back from there onto the last card.
  function ensureLoop(section, wanted) {
    const row = section.querySelector('.reviews__row');
    if (!row) return;

    const copy = row.querySelector('[data-reviews-clone]');
    if (wanted === Boolean(copy)) return;

    if (!wanted) {
      copy.remove();
      return;
    }

    const first = originals(section)[0];
    if (!first) return;

    const made = first.cloneNode(true);
    made.setAttribute('data-reviews-clone', '');

    // Scenery, not content. It says the same thing as the card it copies, so
    // it is kept out of the reading order and out of the tab order, and every
    // hook the editor identifies a block by is taken off it — a duplicated id
    // is what would otherwise have the editor selecting the wrong card.
    made.setAttribute('aria-hidden', 'true');
    made.inert = true;
    for (const node of [made, ...made.querySelectorAll('*')]) {
      node.removeAttribute('id');
      for (const attr of [...node.attributes]) {
        if (attr.name.startsWith('data-shopify')) node.removeAttribute(attr.name);
      }
    }

    row.append(made);
  }

  // Moving the track with the transition switched off, for the single frame in
  // which the loop is closed.
  function withoutMotion(row, apply) {
    row.setAttribute('data-instant', '');
    apply();
    // Read something laid out, so the browser settles on this position now
    // rather than folding it in with whatever is set immediately after.
    void row.offsetWidth;
    row.removeAttribute('data-instant');
  }

  function paint(section, index, instant) {
    const row = section.querySelector('.reviews__row');
    const viewport = section.querySelector('.reviews__viewport');
    if (!row || !viewport) return;

    const panes = slides(section);
    if (!panes.length) return;

    const at = Math.min(Math.max(index, 0), panes.length - 1);
    section.dataset.reviewsIndex = String(at);

    const put = () => {
      row.style.setProperty('--reviews-offset', at * viewport.clientWidth + 'px');
      panes.forEach((pane, n) => {
        pane.toggleAttribute('data-reviews-current', n === at);
      });
    };

    if (instant) withoutMotion(row, put);
    else put();
  }

  function step(section, dir) {
    const count = originals(section).length;
    if (!count) return;

    let at = Number(section.dataset.reviewsIndex || 0);

    // Still standing on the copy, which happens whenever the wrap could not be
    // timed off the end of a transition because there was no transition to
    // time it off — someone who asked for less motion has none.
    if (at >= count) {
      at -= count;
      paint(section, at, true);
    }

    if (dir > 0) {
      // Onto the copy when this is the last card. It looks like the first, and
      // is exchanged for the first once the step has finished.
      paint(section, at + 1, false);
      return;
    }

    if (at === 0) {
      // The same card, at the other end of the row, and then an ordinary step
      // back from there. Nothing to see in the first move: it is the picture
      // already on screen.
      paint(section, count, true);
      paint(section, count - 1, false);
      return;
    }

    paint(section, at - 1, false);
  }

  function show(section, index) {
    const row = section.querySelector('.reviews__row');
    const viewport = section.querySelector('.reviews__viewport');
    if (!row || !viewport) return;
    if (!originals(section).length) return;

    const looping = onePerView(section);
    ensureLoop(section, looping);

    if (looping) {
      const count = originals(section).length;
      paint(section, ((index % count) + count) % count, true);
      section.querySelectorAll('.reviews__arrow').forEach((b) => {
        b.disabled = false;
      });
      return;
    }

    const list = cards(section);
    if (!list.length) return;

    // Measured off the last card rather than off scrollWidth: a scroll width
    // does not count trailing padding, so the tail that keeps the last card
    // clear of the screen edge was being ignored and the track stopped flush.
    const tail = parseFloat(getComputedStyle(row).paddingInlineEnd) || 0;
    const end = list[list.length - 1];
    const trackEnd = end.offsetLeft - row.offsetLeft + end.offsetWidth + tail;
    const limit = Math.max(0, trackEnd - viewport.clientWidth);
    const clamped = Math.min(Math.max(index, 0), list.length - 1);
    // Clamped at both ends: a card's offsetLeft is measured against its own
    // offset parent, which is not always the row, so the first one can come
    // out slightly negative and pull the track off its start.
    // On the last card the track goes to its own end rather than to that
    // card's start — otherwise the card sits at the left of the viewport and
    // runs off the right, and the tail meant to hold it clear never applies.
    const wanted = clamped === list.length - 1
      ? limit
      : Math.max(0, Math.min(list[clamped].offsetLeft - row.offsetLeft, limit));

    section.dataset.reviewsIndex = String(clamped);
    row.style.setProperty('--reviews-offset', wanted + 'px');

    section.querySelectorAll('.reviews__arrow').forEach((b) => {
      const dir = Number(b.dataset.reviewsStep);
      b.disabled = dir < 0 ? wanted <= 0 : wanted >= limit;
    });
  }

  function initReviews(root) {
    (root || document).querySelectorAll('.reviews').forEach((section) => {
      if (section.dataset.reviewsWired === 'true') return;
      section.dataset.reviewsWired = 'true';

      section.querySelectorAll('.reviews__arrow').forEach((b) => {
        b.addEventListener('click', () => {
          const dir = Number(b.dataset.reviewsStep);
          if (onePerView(section)) {
            step(section, dir);
            return;
          }
          show(section, Number(section.dataset.reviewsIndex || 0) + dir);
        });
      });

      // The step that landed on the copy is over, so the track can be put back
      // onto the real first card unseen. This is what leaves the next step
      // somewhere to go, and it is timed off the end of the movement rather
      // than off a clock, so it cannot land early and be seen.
      const row = section.querySelector('.reviews__row');
      if (row) {
        row.addEventListener('transitionend', (event) => {
          if (event.target !== row || event.propertyName !== 'translate') return;
          const count = originals(section).length;
          const at = Number(section.dataset.reviewsIndex || 0);
          if (count && at >= count) paint(section, at - count, true);
        });
      }

      // A width change moves every card, so the offset has to be recomputed
      // against the new geometry rather than kept.
      window.addEventListener('resize', () => {
        show(section, Number(section.dataset.reviewsIndex || 0));
      });

      show(section, 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initReviews());
  } else {
    initReviews();
  }

  document.addEventListener('shopify:section:load', (event) => initReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steps"] && !Shopify.designMode) return;
  try {
    
  // One card along per press, and each arrow greyed at the end it cannot go
  // past. The track scrolls natively — this only moves it, and listens.
  function initSteps(root) {
    (root || document).querySelectorAll('.steps').forEach((section) => {
      const row = section.querySelector('.steps__row');
      const prev = section.querySelector('.steps__step--prev');
      const next = section.querySelector('.steps__step--next');
      if (!row || !prev || !next || row.dataset.bound) return;
      row.dataset.bound = 'true';

      const stride = () => {
        const card = row.querySelector('.step');
        const gap = parseFloat(getComputedStyle(row).columnGap) || 0;
        return card ? card.offsetWidth + gap : row.clientWidth;
      };

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      const go = (direction) => {
        row.scrollBy({ left: direction * stride(), behavior: reduce.matches ? 'auto' : 'smooth' });
      };

      const update = () => {
        const end = row.scrollWidth - row.clientWidth - 2;
        prev.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft >= end;
      };

      prev.addEventListener('click', () => go(-1));
      next.addEventListener('click', () => go(1));
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  initSteps(document);
  document.addEventListener('shopify:section:load', (event) => initSteps(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["venues"] && !Shopify.designMode) return;
  try {
    
  // Each venue works out where its dot goes and carries it on the list item;
  // this draws the dots onto the map. The map is one element and the venues
  // are blocks rendered elsewhere, so nothing in Liquid can put the two
  // together — without this the list still works and the map is bare.
  const SVG = 'http://www.w3.org/2000/svg';

  function plotVenues(root) {
    (root || document).querySelectorAll('.venues').forEach((section) => {
      section.querySelectorAll('.map').forEach((map) => plotOn(section, map));
      limitVenues(section);
    });
  }

  function plotOn(section, map) {
    map.querySelectorAll('.map__dot').forEach((dot) => dot.remove());

    section.querySelectorAll('.venue[data-x][data-y]').forEach((venue) => {
      const dot = document.createElementNS(SVG, 'circle');
      dot.setAttribute('class', 'map__dot');
      dot.setAttribute('cx', venue.dataset.x);
      dot.setAttribute('cy', venue.dataset.y);
      dot.setAttribute('r', '5');
      dot.dataset.region = venue.dataset.region;

      const title = document.createElementNS(SVG, 'title');
      title.textContent = venue.textContent.trim();
      dot.append(title);
      map.append(dot);
    });
  }

  // The first few of the chosen region, and a button for the rest: four on
  // a phone, six — three rows of two — wider. Marked here,
  // where the region is known; hidden in CSS only while the button shows.
  const phone = window.matchMedia('(max-width: 42rem)');
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');

  function limitVenues(section) {
    const more = section.querySelector('.venues__more');
    const picked = section.querySelector('.venues__pick:checked');
    if (!more || !picked) return;

    const inRegion = [...section.querySelectorAll('.venue')].filter(
      (venue) => venue.dataset.region === picked.value
    );
    section.querySelectorAll('.venue.is-extra').forEach((venue) => venue.classList.remove('is-extra'));
    const first = phone.matches ? 4 : 6;
    inRegion.slice(first).forEach((venue) => venue.classList.add('is-extra'));
    more.hidden = inRegion.length <= first;
    setOpen(section, more, false);
  }

  // The card's height is remembered after every change, so the next one can
  // be eased from it: by the time a radio reports its change the new region
  // is already laid out, and the old height would otherwise be gone.
  function easeCard(section) {
    const card = section.querySelector('.venues__card');
    if (!card) return;
    const from = parseFloat(card.dataset.height) || card.offsetHeight;
    const to = card.offsetHeight;
    card.dataset.height = to;
    if (still.matches || Math.abs(from - to) < 1) return;
    card.animate(
      [{ blockSize: from + 'px', overflow: 'hidden' }, { blockSize: to + 'px', overflow: 'hidden' }],
      { duration: 420, easing: 'cubic-bezier(0.65, 0, 0.35, 1)' }
    );
  }

  document.addEventListener('change', (event) => {
    if (!event.target.matches('.venues__pick')) return;
    const section = event.target.closest('.venues');
    limitVenues(section);
    easeCard(section);
  });

  function setOpen(section, more, open) {
    section.classList.toggle('is-open', open);
    more.setAttribute('aria-expanded', String(open));
    more.textContent = open ? more.dataset.less : more.dataset.more;
  }

  // Opening and closing ease the card between its two heights, and the names
  // that arrive fade up into place. Measured either side of the change and
  // animated between, since a height of auto cannot be transitioned.
  function toggleMore(more) {
    const section = more.closest('.venues');
    const card = section.querySelector('.venues__card');
    const opening = !section.classList.contains('is-open');
    const from = card.offsetHeight;

    setOpen(section, more, opening);
    if (still.matches) return;

    const to = card.offsetHeight;
    card.dataset.height = to;
    if (from !== to) {
      card.animate(
        [{ blockSize: from + 'px', overflow: 'hidden' }, { blockSize: to + 'px', overflow: 'hidden' }],
        { duration: 480, easing: 'cubic-bezier(0.65, 0, 0.35, 1)' }
      );
    }

    if (opening) {
      section.querySelectorAll('.venue.is-extra').forEach((venue, index) => {
        if (!venue.offsetParent) return;
        venue.animate(
          [{ opacity: 0, transform: 'translateY(0.5rem)' }, { opacity: 1, transform: 'none' }],
          { duration: 360, delay: 120 + index * 45, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)', fill: 'backwards' }
        );
      });
    }
  }

  document.addEventListener('click', (event) => {
    const more = event.target.closest('.venues__more');
    if (more) toggleMore(more);
  });

  phone.addEventListener('change', () => {
    document.querySelectorAll('.venues').forEach(limitVenues);
  });

  // On a desktop the band is as tall as its left column, and that column
  // grows and shrinks with the card. Reserved instead for the tallest the
  // card can be — the fullest region, opened — so changing region or opening
  // the list never moves the page below. A phone and a tablet carry the map
  // inside the card and flow with it.
  const stacked = window.matchMedia('(max-width: 64rem)');

  function holdHeight(section) {
    const side = section.querySelector('.venues__side');
    const card = section.querySelector('.venues__card');
    const list = section.querySelector('.venues__list');
    const more = section.querySelector('.venues__more');
    const sample = section.querySelector('.venue:not(.is-extra)');
    if (!side || !card || !list || !more) return;

    side.style.removeProperty('min-block-size');
    if (stacked.matches || !sample || !sample.offsetHeight) return;

    const counts = {};
    section.querySelectorAll('.venue').forEach((venue) => {
      counts[venue.dataset.region] = (counts[venue.dataset.region] || 0) + 1;
    });
    const most = Math.max(0, ...Object.values(counts));
    const columns = getComputedStyle(list).gridTemplateColumns.split(' ').length;
    const rows = Math.ceil(most / columns);

    const cardStyle = getComputedStyle(card);
    const rowGap = parseFloat(getComputedStyle(list).rowGap) || 0;
    let tallest = parseFloat(cardStyle.paddingTop) + parseFloat(cardStyle.paddingBottom)
      + rows * sample.offsetHeight + Math.max(0, rows - 1) * rowGap;

    if (most > 6) {
      const wasHidden = more.hidden;
      more.hidden = false;
      const moreStyle = getComputedStyle(more);
      tallest += more.offsetHeight + parseFloat(moreStyle.marginTop) + parseFloat(moreStyle.marginBottom);
      more.hidden = wasHidden;
    }

    const room = side.offsetHeight - card.offsetHeight + Math.ceil(tallest);
    side.style.minBlockSize = room + 'px';
  }

  plotVenues(document);
  document.querySelectorAll('.venues').forEach(holdHeight);
  document.querySelectorAll('.venues__card').forEach((card) => {
    card.dataset.height = card.offsetHeight;
  });

  let rehold;
  window.addEventListener('resize', () => {
    clearTimeout(rehold);
    rehold = setTimeout(() => document.querySelectorAll('.venues').forEach(holdHeight), 200);
  });
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => document.querySelectorAll('.venues').forEach(holdHeight));
  }
  document.addEventListener('shopify:section:load', (event) => {
    plotVenues(event.target);
    event.target.querySelectorAll('.venues').forEach(holdHeight);
  });
  document.addEventListener('shopify:block:select', (event) => plotVenues(event.target.closest('.shopify-section')));

  } catch(e) { console.error(e); }
})();
})();
